import { render, staticRenderFns } from "./OrganizationDetail.vue?vue&type=template&id=166f3cd5"
import script from "./OrganizationDetail.vue?vue&type=script&lang=ts"
export * from "./OrganizationDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports